import { Actions, type SeedListReducerState } from '@openx/types/segments';
import type { Action } from './types';

export const reducerSeedList = (state: SeedListReducerState, action: Action): SeedListReducerState => {
  switch (action.type) {
    case Actions.ADD_ITEM:
      return { ...state, listData: [...state.listData, action.payload] };
    case Actions.REMOVE_ITEM:
      return { ...state, listData: state.listData.filter(item => item.id !== action.payload.id) };
    case Actions.SET_LIST_DATA:
      return { ...state, listData: action.payload };

    default:
      return state;
  }
};
